// extracted by mini-css-extract-plugin
export default {"checkout_form":"Chekout_checkout_form__DeUBu"};